export default __webpack_public_path__ + "assets/images/Robotviet_WebLogo.png";